import { useSelector, shallowEqual } from 'react-redux';

import {
  setCurrentProduct,
  selectIsCompareView
} from 'state/quote/quote-slice';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { getRadioOptionLabel } from 'components/direct-sales/quote/utils';
import { pushEvent } from 'state/analytics/analytics-slice';
import { RADIO_OPTIONS } from 'components/direct-sales/quote/utils';
import { useNavigation } from 'hooks/useNavigation';
import { setInitialState as resetEmailQuote } from 'state/email-quote/email-quote-slice';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useCallback } from 'react';
import { patchAbandonedCartThunk } from 'state/abandoned-cart/abandoned-cart-thunks';
import { AbandonedCartUpdateStep, useAbandonedCartUpdate } from 'hooks/useAbandonedCart/useAbandonedCartUpdate';
import { selectIsLoadingPatch } from 'state/abandoned-cart/abandoned-cart-slice';
import { TProduct } from 'api/models/TProduct';
import { Product } from 'state/abandoned-cart/types/abandoned-cart';

type SelectTariffCtaProps = {
  children: React.ReactNode;
  product: object;
};

export const SelectTariffCta = ({
  children,
  product
}: SelectTariffCtaProps) => {
  const dispatch = useAppDispatch();
  const {
    isAbandonedCartAvailable,
    buildPayload,
    encryptedQuoteId
  } = useAbandonedCartUpdate(AbandonedCartUpdateStep.SELECT_TARIFF);

  const isCompareView = useSelector(selectIsCompareView, shallowEqual);
  const isLoading = useSelector(selectIsLoadingPatch, shallowEqual);
  const analyticsEvent = {
    category: 'nepsales-energy-final-selection',
    tariffViewType: getRadioOptionLabel(isCompareView, RADIO_OPTIONS)
  };
  const { eventTypes, next } = useNavigation();
  const abandonedCartEnabled =
    isAbandonedCartAvailable &&
    !!encryptedQuoteId

  const patchAbandonedCart = useCallback(async (product: TProduct) => {
    const payload = buildPayload(product as Product);
    try {
      await dispatch(patchAbandonedCartThunk(payload, encryptedQuoteId));
    } catch (error) {
      console.error('PATCH Abandoned cart failed', error)
    }
  }, [buildPayload, dispatch, encryptedQuoteId])

  const handleGoNext = async () => {
    dispatch(resetEmailQuote());
    dispatch(setCurrentProduct(product));
    dispatch(pushEvent(analyticsEvent));

    abandonedCartEnabled && await patchAbandonedCart(product);
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <div>
      <NsPrimaryCta isLoading={isLoading} onClick={handleGoNext}>{children}</NsPrimaryCta>
    </div>
  );
};
